function ReducedFunctionalityMessage() {
    return null; // We do not need to show this message on web and desktop
}

ReducedFunctionalityMessage.displayName = 'ReducedFunctionalityMessage';

export default ReducedFunctionalityMessage;
